import React, { createContext, useState } from "react";

const GeolocationContext = createContext();

export function GeolocationProvider({ initialLocation, children }) {
  const [location, setLocation] = useState(initialLocation);

  return (
    <GeolocationContext.Provider value={[location, setLocation]}>
      {children}
    </GeolocationContext.Provider>
  );
}

const useGeolocation = () => {
  const context = React.useContext(GeolocationContext);
  if (context === undefined) {
    throw new Error("useGeolocation must be used within a GeolocationContext");
  }
  return context;
};

export default useGeolocation;
